import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const RankingMethodologyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 32px;
`;

export const StyledLabel = styled.span`
  ${typographyV2.titleSm};
  color: var(--text-soft);
`;

